import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Pencil({
  width = 20,
  height = 20,
  color = '#656565',
  className,
  ...rest
}: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2792 4.2805C14.6766 3.88305 15.321 3.88306 15.7185 4.28053C16.1159 4.67798 16.1159 5.32236 15.7184 5.7198L15.0822 6.35602C14.2951 6.34714 13.6518 5.70384 13.6429 4.91677L14.2792 4.2805ZM12.3937 4.04464C12.3876 4.05053 12.3816 4.05653 12.3757 4.06263L4.88856 11.5497L4.84447 11.5938C4.41987 12.0183 4.14606 12.292 3.92037 12.606C3.7204 12.8841 3.5511 13.1831 3.41545 13.4977C3.26235 13.8528 3.16849 14.2284 3.02295 14.8109L3.00783 14.8714L2.60444 16.4849C2.54054 16.7405 2.61543 17.0109 2.80172 17.1972C2.988 17.3835 3.25837 17.4584 3.51395 17.3945L5.12751 16.9911L5.18799 16.976C5.77048 16.8304 6.1461 16.7365 6.50116 16.5834C6.81575 16.4478 7.11475 16.2785 7.39293 16.0785C7.70688 15.8528 7.98062 15.579 8.40511 15.1545L8.4492 15.1104L15.9395 7.62004C15.9434 7.61622 15.9473 7.61237 15.9511 7.60847L16.7791 6.78046C17.7623 5.79724 17.7623 4.20313 16.7791 3.21989C15.7959 2.23662 14.2017 2.2366 13.2185 3.21984L12.3937 4.04464ZM13.8561 7.5821L7.38854 14.0497C6.90531 14.5329 6.72043 14.7146 6.51739 14.8606C6.32706 14.9974 6.12248 15.1132 5.90723 15.206C5.67761 15.305 5.42669 15.3701 4.76371 15.5359L4.36282 15.6361L4.46304 15.2352C4.62879 14.5722 4.69384 14.3213 4.79285 14.0917C4.88567 13.8764 5.0015 13.6718 5.13833 13.4815C5.28429 13.2785 5.46598 13.0936 5.94921 12.6104L12.4168 6.14281C12.7117 6.77475 13.2242 7.28726 13.8561 7.5821Z"
        fill={color}
      />
    </svg>
  );
}
